(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ClicktimeProtectionSettingsController', ["$scope", "modulesDao", function ($scope, modulesDao) {
        $scope.loading = false;
        $scope.availableProps = ['configuration_mode'];
        $scope.model = {};
        modulesDao.retrieveConfig('clicktime_protection').then(function (res) {
            _(res.data).each(function (val, prop) {
                if (_($scope.availableProps).findIndex(function (p) {
                        return p === prop;
                    }) !== -1) {
                    $scope.model[prop] = {
                        type: val.type,
                        label: val.label,
                        tooltip: val.tooltip,
                        value: val.value,
                        variants: val.variants || []
                    };
                }
            });
        });
        $scope.save = function () {
            $scope.loading = true;
            var body = {};
            _($scope.availableProps).each(function (prop) {
                if ($scope.model[prop] !== undefined && $scope.model[prop].value !== undefined) {
                    body[prop] = $scope.model[prop].value;
                }
            });
            return modulesDao.saveConfig('clicktime_protection', body).then(function () {
                $scope.loading = false;
            });
        };
    }]);
}());